import script from "./ContentFuelComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentFuelComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContentFuelComponent.vue?vue&type=style&index=0&id=98f6fb86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98f6fb86"]])

export default __exports__